const map = {
	"./new01.jpg": 6638,
	"./new02.jpg": 9721,
	"./new03.jpg": 1676,
	"./new04.jpg": 6519,
	"./new05.jpg": 9034,
	"./new06.jpg": 5285,
	"./new07.jpg": 8120,
	"./new08.jpg": 6259,
	"./new09.jpg": 9798,
	"./new10.jpg": 9244,
	"./new11.jpg": 9769,
	"./new12.jpg": 9502,
	"./new13.jpg": 7547,
	"./new14.jpg": 808,
	"./new15.jpg": 5125,
	"./new16.jpg": 9402,
	"./new17.jpg": 791,
	"./new18.jpg": 8708,
	"./new19.jpg": 513,
	"./new20.jpg": 2221,
	"./new21.jpg": 1296,
	"./new22.jpg": 5631
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8735;